import { Controller } from "@hotwired/stimulus"

// Right / Wrong on one of Jane's memories (memories/_line_body), graded where it
// is (MemoryReviewsController#grade, as JSON). "Wrong" on your own forgets it,
// and the line goes.
//
// Its own controller because two timelines carry these lines: the brief's
// memory timeline and the contact card's one timeline, where a memory is a row
// among emails and meetings. Each owner re-applies its filter its own way - the
// brief's listens for memory-grade:forgotten, the card's notices its row target
// disconnecting.
export default class extends Controller {
    async grade(event) {
        const button = event.currentTarget
        const actions = button.closest(".memory-line-actions")
        const buttons = () => actions.querySelectorAll("button[data-action*='grade']")
        buttons().forEach((b) => (b.disabled = true))
        try {
            const response = await fetch(button.dataset.url, {
                method: "POST",
                headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content },
                credentials: "same-origin"
            })
            if (!response.ok) throw new Error(String(response.status))
            if (button.dataset.forgets === "true") {
                button.closest("[data-memory-line]")?.remove()
                this.dispatch("forgotten")
                return
            }
            const note = document.createElement("span")
            note.className = "memory-line-graded small"
            note.textContent = button.dataset.url.includes("verdict=correct") ? "Thanks - marked right." : "Thanks - its owner will look."
            buttons().forEach((b) => b.remove())
            actions.prepend(note)
        } catch (_error) {
            buttons().forEach((b) => (b.disabled = false))
        }
    }
}
